export const enumToArray = <T>(en: any, toSkipIndexes: number[] = []) => {
  let map: { key: string; value: T }[] = [];

  for (var n in en) {
    if (typeof en[n] === 'number') {
      if (!toSkipIndexes.includes(en[n])) {
        map.push({ value: en[n], key: n });
      }
    }
  }
  return map;
};
